import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">The Catholic Church in Kenya</p>
        <h1>Catholic Kenya</h1>
        <p className="lede">
          Kenya's roughly 17 million Catholics make up about 31.7% of the national population, with the Church playing a leading role in education, healthcare, and civic life across the country.
        </p>
        <div className="cta-row">
          <a href="#structure">
            Church Structure
          </a>
          <a href="#impact" className="secondary">
            Community Impact
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>A Major National Presence</h2>
          <p>
            Catholics represent roughly 31.7% of Kenya's population -- about 17 million people -- organized across four ecclesiastical provinces and twenty-five dioceses.
          </p>
        </article>
        <article>
          <h2>A Leading Civic Institution</h2>
          <p>
            Beyond parish life, the Kenyan Church is a principal actor in education and healthcare nationally, run through more than 1,100 parishes and 5,839 mission stations.
          </p>
        </article>
        <article>
          <h2>A Well-Staffed Church</h2>
          <p>
            Kenya's dioceses are served by 3,747 priests -- 2,243 diocesan and 1,504 religious -- reflecting one of the more institutionally developed Catholic Churches in East Africa.
          </p>
        </article>
      </section>

      <section className="section" id="structure">
        <h2>Dioceses & Current Leadership</h2>
        <p className="section-sub">Kenya has 4 Metropolitans and 22 suffragan dioceses, with 32 bishops nationally.</p>
        <div className="directory-list">
          <article className="directory-item">
            <h3>Archdiocese of Nairobi</h3>
            <p>Auxiliary Bishop Obed Muriungi Karobia, appointed March 26, 2026</p>
          </article>
          <article className="directory-item">
            <h3>Archdiocese of Mombasa</h3>
            <p>Coadjutor Archbishop Dominic Kimengich, appointed January 28, 2026</p>
          </article>
          <article className="directory-item">
            <h3>Diocese of Meru</h3>
            <p>Bishop Jackson Murugara, succeeded Bishop Salesius Mugambi January 1, 2026</p>
          </article>
          <article className="directory-item">
            <h3>Diocese of Kitui</h3>
            <p>Bishop John Mbua Mwandi, appointed May 27, 2026</p>
          </article>
        </div>
      </section>

      <section className="section" id="news">
        <h2>Latest News</h2>
        <p className="section-sub">Recent, sourced developments -- updated as new stories are verified.</p>
        <div className="news-list">
          <article className="news-item">
            <p className="news-date">Early 2026</p>
            <h3>A wave of new episcopal appointments across Kenya</h3>
            <p>Kenya saw multiple new bishop appointments in 2026, including at Meru, Kitui, Mombasa (coadjutor), and an auxiliary bishop for Nairobi -- a significant leadership refresh nationally.</p>
            <p className="news-source">Source: ACI Africa, Wikipedia</p>
          </article>
          <article className="news-item">
            <p className="news-date">February 2026</p>
            <h3>Bungoma diocese calls for Lenten spiritual renewal</h3>
            <p>The Catholic Diocese of Bungoma called on the faithful to undertake spiritual renewal during the 2026 Lenten season, beginning Ash Wednesday, February 18.</p>
            <p className="news-source">Source: ACI Africa</p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default App;
